export interface Uship {
  orderNumber: string;
  priority: string;
  recipientName: string;
  recipientPhone?: string;
  boxCount: number;
  expectedDeliveryDate?: string;
  actualDeliveryDate?: string;
  addresses: Address[];
  shipOptions: ShipOptions[];
  selectedShipOptions: any;
  pieceInfos?: PieceInfos[];
  masterTrackingNumber?: string;
  status?: string;
  overrides?: Overrides;
  warnings?: string[];
  orderLabelZpl?: string;
}

export interface Address {
  streetLines: string[];
  city: string;
  stateOrProvinceCode?: string;
  postalCode: string;
  countryCode: string;
}

export interface ShipOptions {
  cost?: number;
  serviceName?: string;
  daysToGetThere?: number;
  deliveryDate?: string;
  serviceType?: string;
}

export interface PieceInfos {
  trackingNumber?: string;
  zpl?: string;
}

export interface Overrides {
  service_type: string;
}

export type BundleStatus = 'accumulating' | 'ready' | 'shipped';

export interface Bundle {
  id: string;
  barcode: string;
  slot: number;
  drOrgId: number;
  orderType: number;
  destination: Address;
  seedOrder: string;
  expectedOrders: string[];
  scannedOrders: string[];
  status: BundleStatus;
  createdAt: string;
}

export type BundleScanAction =
  | 'bundle_created'
  | 'order_received'
  | 'confirm_partial';

export interface BundleScanResult {
  action: BundleScanAction;
  bundle: Bundle;
  scannedOrder?: string;
  missingOrders?: string[];
  message: string;
  manifestZpl?: string;
  orderLabelZpl?: string;
}

export type ScanResponse = Uship | BundleScanResult;

export const isBundleScanResult = (x: ScanResponse): x is BundleScanResult =>
  typeof (x as BundleScanResult).action === 'string';
